import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-search-input',
  standalone: false,
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.css'],
})
export class SearchInputComponent {
  searchValue: string = '';
  @Output() searchValueChange: EventEmitter<string> =
    new EventEmitter<string>();

  constructor() {}

  onSearchValueChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.searchValueChange.emit(inputElement.value);
  }

  resetSearch(): void {
    this.searchValue = '';
    this.searchValueChange.emit('');
  }
}
